import type { CardProps } from "./types";
import { useCardStyles } from "./styles";
import { Icon } from "../icon";
import type { IconName } from "../icon/iconsMap";

export const Card = ({
  children,
  backgroundImage,
  style,
  onPress,
  ...props
}: CardProps) => {
  const styles = useCardStyles(props);

  const isRemoteImage =
    typeof backgroundImage === "string" && backgroundImage.includes("http");

  return (
    <div
      role={onPress ? "button" : "region"}
      tabIndex={onPress ? 0 : undefined}
      onClick={onPress}
      style={{
        ...styles.container,
        ...(isRemoteImage
          ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {}),
        ...style,
      }}
      {...props}
    >
      {!isRemoteImage && backgroundImage && (
        <Icon name={backgroundImage as IconName} size="100%" />
      )}

      {children}
    </div>
  );
};

Card.displayName = "Card";
